module.exports = __webpack_public_path__ + "static/media/certification.b74eb8c0.svg";